export { default } from './Portal';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/Portal/index.js
// module id = 819
// module chunks = 0